import getScrollbarSize from '@mui/utils/getScrollbarSize';

export default getScrollbarSize;
